/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const notifications = (state = defaultState.notifications, action) => {
    let nextState = Utilities.deepClone(state);

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.NOTIFICATIONS_LIST:
                nextState = action.payload;
                break;

            case constants.NOTIFICATIONS_CLEAR:
                // TODO: figure out how to format the return data
                break;

            default:
                break;

        }
    }

    return nextState;
};
